<template>
  <VDialogV3
    id="package-card"
    position="right"
    width="600px"
    height="100vh"
    :entity="localPackage"
    :context-menu="PackagesService.contextMenu"
    :submit-method="submit"
    :submit-disabled="saveDisabled"
  >
    <section>
      <VInput
        ref="nameInput"
        v-model="localPackage.name"
        label="Название"
        layout="vertical"
        required
        :validate-method="validateName"
      />

      <VInput
        ref="codeInput"
        v-model="localPackage.code"
        label="Код"
        layout="vertical"
        required
        :validate-method="validateCode"
      />
    </section>
  </VDialogV3>
</template>

<script lang="ts">

import Package            from '@/domains/Packages/Package';
import PackagesService    from '@/domains/Packages/PackagesService';

export default defineComponent({
  name: 'PackageCard',

  props: {
    package: {
      type:    Object,
      default: null,
    },
    id: {
      type:    Number,
      default: null,
    },
  },

  setup() {
    return {
      PackagesService,
    };
  },

  data() {
    return {
      localPackage: null as Package | null,

      /** Сохранённые значения — своё же название и код дублем не считаются */
      initialName: null as string | null,
      initialCode: null as string | null,
    };
  },

  computed: {
    /**
     * Причина запрета сохранения (строка → :submit-disabled показывает тултип).
     * Удалённый вид упаковки редактировать нельзя. Валидность полей ведёт сам VDialogV3.
     */
    saveDisabled(): string | null {
      if (this.localPackage?.isDeleted === true) {
        return 'Вид упаковки удалён';
      }
      else {
        return null;
      }
    },
  },

  async mounted() {
    await this.init();
  },

  methods: {
    async init(): Promise<void> {
      if (this.id) {
        this.localPackage = await PackagesService.get(this.id);
      }
      else if (this.package instanceof Package) {
        this.localPackage = this.$core.utils.cloneDeep(this.package);
      }
      else {
        this.localPackage = new Package();
      }

      this.initialName = this.localPackage.name;
      this.initialCode = this.localPackage.code;
    },

    async submit(): Promise<boolean> {
      if (this.localPackage!.isExisting === true) {
        return await PackagesService.update(this.localPackage!);
      }
      else {
        return await PackagesService.add(this.localPackage!);
      }
    },

    // ==================== Валидация ====================

    validateName(value: string): string | null | Promise<string | null> {
      if (typeof value !== 'string' || value.length === 0) { return null; }
      if (value.length > 200) { return 'Максимальная длина поля 200 символов'; }
      if (value === this.initialName) { return null; }

      return PackagesService.getList({ name: value }).then(list => {
        return list.length > 0 ? 'Ошибка уникальности. Данное название уже существует' : null;
      });
    },

    validateCode(value: string): string | null | Promise<string | null> {
      if (typeof value !== 'string' || value.length === 0) { return null; }
      if (value.length > 10) { return 'Максимальная длина поля 10 символов'; }
      if (value === this.initialCode) { return null; }

      return PackagesService.getList({ code: value }).then(list => {
        return list.length > 0 ? 'Ошибка уникальности. Данный код уже существует' : null;
      });
    },
  },
});
</script>